import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Token storage — a Bearer fallback so auth works even when the browser drops
// our SameSite=None cookies (Safari/iPhone "Prevent Cross-Site Tracking", private mode).
const AT_KEY = "jc_at";
const RT_KEY = "jc_rt";
export const getAccessToken = () => { try { return localStorage.getItem(AT_KEY); } catch { return null; } };
export const getRefreshToken = () => { try { return localStorage.getItem(RT_KEY); } catch { return null; } };
export const setTokens = (access, refresh) => {
  try {
    if (access) localStorage.setItem(AT_KEY, access);
    if (refresh) localStorage.setItem(RT_KEY, refresh);
  } catch {}
};
export const clearTokens = () => {
  try { localStorage.removeItem(AT_KEY); localStorage.removeItem(RT_KEY); } catch {}
};

export const api = axios.create({ baseURL: API, withCredentials: true });

// Attach the Bearer token (if we have one) on every request.
api.interceptors.request.use((config) => {
  const t = getAccessToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Auto-refresh the access token once on 401, then retry the original request.
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    if (
      error.response?.status === 401 &&
      original &&
      !original._retry &&
      !url.includes("/auth/")
    ) {
      original._retry = true;
      try {
        refreshing =
          refreshing ||
          api.post("/auth/refresh", null, {
            headers: getRefreshToken() ? { "X-Refresh-Token": getRefreshToken() } : {},
          });
        const { data } = await refreshing;
        refreshing = null;
        if (data?.access_token) setTokens(data.access_token, null);
        return api(original);
      } catch (e) {
        refreshing = null;
        clearTokens();
        if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export function errMsg(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return JSON.stringify(detail);
}
